<script>
  import Alert from './Alert'
  import AlertIOS from './AlertIOS'
  import Confirm from './Confirm'
  import ConfirmIOS from './ConfirmIOS'

  export default {
    Alert,
    AlertIOS,
    Confirm,
    ConfirmIOS
  }
</script>



// WEBPACK FOOTER //
// index.vue?2aab4058